import React, { Component } from 'react';
import DBService from '../../service/DBService';
import { Link } from 'react-router-dom';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Form, InputGroup, Button, Row, Col } from 'react-bootstrap';
import paginationFactory from 'react-bootstrap-table2-paginator';
import MediaQuery from 'react-responsive';
import { getCookie } from '../../service/Cookie';

let searchInputValue = '';

const options = {
    sizePerPage: 20,
    hideSizePerPage: true,
};

const MySearch = (props) => {
    let input;
    const handleClick = () => {
        props.onSearch(input.value);
        searchInputValue = input.value;
    };

    return (
        <div>
            <InputGroup size="sm" className="mb-3">
                <Form.Control size="sm" type="text" placeholder="Filter" value={searchInputValue} onChange={handleClick} ref={n => input = n} />
            </InputGroup>
        </div>
    );
};

const mobileColumns = [
    {
        dataField: "symbol",
        text: "Ticker",
        sort: true,
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "keywords",
        text: "Keywords",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "title",
        text: "Title",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
];

const columns = [
    {
        dataField: "symbol",
        text: "Ticker",
        sort: true,
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "keywords",
        text: "Keywords",
        sort: true,
        headerStyle: { fontSize: '10px' },
        hidden: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "title",
        text: "Title",
        sort: true,
        headerStyle: { fontSize: '10px' },
        hidden: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "url",
        text: "Link",
        sort: true,
        formatter: (cell, row) => <a target="_blank" href={cell}>{cell}</a>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left',
                wordBreak: 'break-all' 
            }
        }
    },
    {
        dataField: "createdDate",
        text: "Date",
        sort: true,
        headerStyle: { fontSize: '10px' },
        hidden: false,
    },
];

const rowStyle = (row, rowIndex) => {
    const style = {};
    style.fontSize = '10px';
    style.textAlign = 'right';
    return style;
};

class UserNewsNotificationsListDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            reload: false,
            columns: columns,
            mobileColumns: mobileColumns,
            searchInputValue: ''
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.interval = setInterval(() => { this.getData() }, 1000 * 10 * 15); //15 mins
        this.getData();
    }

    changeHidden = () => {
        let screenWidth = window.screen.width;
        const newColumns = this.state.columns.map((column) => {
            if (screenWidth < 500) {
                if (column.dataField === 'name' || column.dataField === 'dayLow' || column.dataField === 'dayHigh' || column.dataField === 'open') {
                    column.hidden = true;
                }
            } else {
                column.hidden = false;
            }
            return column;
        });
        this.setState({ columns: newColumns, reload: true });
    }

    getUserId() {
        let userId = '';
        let cookieValue = getCookie();
        if (cookieValue !== undefined && cookieValue.userId !== undefined) {
            console.log('Setting userId', cookieValue.userId);
            userId = cookieValue.userId;
        }
        return userId;
    }

    getData() {
        let body ={
            userId: this.getUserId()
        }
        DBService.userNewsNotifications(body)
            .then(result => {
                result = result.data;
                console.log('userNewsNotifications', result);
                if (result !== undefined && result.length > 0) {
                    this.setState({ list: result, reload: true });
                } else {
                    this.setState({ list: [], reload: true });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    deleteAll = () =>{
        let body ={
            userId: this.getUserId()
        }
        DBService.userNewsNotificationsDelete(body)
            .then(result => {
                result = result.data;
                console.log('userNewsNotificationsDelete', result);
                this.getData();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    custom_sort(a, b) {
        if (a.volume > b.volume) { return -1; }
        if (a.volume < b.volume) { return 1; }
        return 0;
    }

    render() {
        // if (this.state.reload) {
        //     console.log('userNotifications Reloading...');
        //     this.setState({ reload: false });
        //     return (<div>Loading...</div>);
        // }
        return (
            <>
                <MediaQuery minWidth={501}>
                    <ToolkitProvider
                        keyField="symbol"
                        data={this.state.list}
                        columns={this.state.columns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>
                                    <Row>
                                        <Col>
                                            <MySearch {...props.searchProps} />
                                        </Col>
                                        <Col xs={4} sm={2} md={2} lg={2}>
                                            <Button variant="danger" onClick={this.deleteAll} size="sm">Delete All</Button>
                                        </Col>
                                    </Row>
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        hover
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>

                <MediaQuery maxWidth={500}>
                    <ToolkitProvider
                        keyField="symbol"
                        data={this.state.list}
                        columns={this.state.mobileColumns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>
                                    <Row>
                                        <Col>
                                            <MySearch {...props.searchProps} />
                                        </Col>
                                        <Col xs={4} sm={2} md={2} lg={2}>
                                            <Button variant="danger" onClick={this.deleteAll} size="sm">Delete All</Button>
                                        </Col>
                                    </Row>
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        hover
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>
                {/* <div style={{textAlign: 'left'}}>
                    Screen refresh every 15 mins
                </div> */}
            </>
        );
    }
}

export default UserNewsNotificationsListDisplay;
